const AmericanPie = [
	'* = strum once',
	'The C minor chord which is played in verse 4 may be a mistake but it is on the recording.',
	'',
	'[Verse 1]',
	'A long, long time ago',
	'I can still remember how that music used to make me smile',
	'And I knew if I had my chance',
	"That I could make those people dance and maybe they'd be happy for a while",
	"But February made me shiver, with every paper I'd deliver",
	"Bad news on the doorstep, I couldn't take one more step",
	"I can't remember if I cried when I read about his widowed bride",
	'Something touched me deep inside',
	'The day the music died',
	'',
	'[Chorus]',
	'So bye, bye Miss American Pie',
	'Drove my Chevy to the levee but the levee was dry',
	"And them good old boys were drinkin' whiskey and rye",
	"Singin' this will be the day that I die, this will be the day that I die",
	'',
	'[Verse 2]',
	'Did you write the book of love',
	'And do you have faith in God above, if the bible tells you so?',
	'Do you believe in rock and roll',
	'Can music save your mortal soul and can you teach me how to dance real slow?',
	"Well I know that you're in love with him 'cuz I saw you dancin' in the gym",
	'You both kicked off your shoes, man I dig those rhythm and blues',
	"I was a lonely teenage bronckin' buck with a pink carnation and a pickup truck",
	"But I knew I was out of luck the day the music died, I started singin'",
	'',
	'[Chorus]',
	'Bye, bye Miss American Pie',
	'Drove my Chevy to the levee but the levee was dry',
	"And them good old boys were drinkin' whiskey and rye",
	"Singin' this will be the day that I die, this will be the day that I die",
	'',
	'[Verse 3]',
	"Now for ten years we've been on our own",
	"and moss grows fat on a rolling stone but that's not how it used to be",
	'When the jester sang for the king and queen',
	'in a coat he borrowed from James Dean in a voice that came from you and me',
	'Oh, and while the king was looking down, the jester stole his thorny crown',
	'The courtroom was adjourned, no verdict was returned',
	'And while Lennin read a book on Marx, the quartet practiced in the park',
	"And we sang dirges in the dark the day the music died, we were singin'",
	'',
	'[Chorus]',
	'Bye, bye Miss American Pie',
	'Drove my Chevy to the levee but the levee was dry',
	"And them good old boys were drinkin' whiskey and rye",
	"Singin' this will be the day that I die, this will be the day that I die",
	'',
	'[Verse 4]',
	'Helter skelter in a summer swelter',
	"the birds flew off with a fallout shelter, eight miles high and fallin' fast",
	'It landed foul on the grass',
	'the players tried for a forward pass, with the jester on the sidelines in a cast',
	'Now the half-time air was sweet perfume, while sergeants played a marching tune',
	'We all got up to dance, but we never got the chance',
	"'Cuz the players tried to take the field, the marching band refused to yield",
	"Do you recall what was revealed the day the music died, we started singin'",
	'',
	'[Chorus]',
	'Bye, bye Miss American Pie',
	'Drove my Chevy to the levee but the levee was dry',
	"And them good old boys were drinkin' whiskey and rye",
	"Singin' this will be the day that I die, this will be the day that I die",
	'',
	'[Verse 5]',
	'And there we were all in one place',
	'a generation lost in space, with no time left to start again',
	'So come on Jack be nimble, Jack be quick, Jack Flash sat on a candlestick',
	"'cause fire is the devil's only friend",
	'And as I watched him on the stage, my hands were clenched in fists of rage',
	"No angel born in Hell could break that Satan's spell",
	'And as the flames climbed high into the night to light the sacrificial rite',
	"I saw Satan laughing with delight the day the music died, he was singin'",
	'',
	'[Chorus]',
	'Bye, bye Miss American Pie',
	'Drove my Chevy to the levee but the levee was dry',
	"And them good old boys were drinkin' whiskey and rye",
	"Singin' this will be the day that I die, this will be the day that I die",
	'',
	'[Verse 6]',
	'I met a girl who sang the blues',
	'And I asked her for some happy news, but she just smiled and turned away',
	'I went down to the sacred store',
	"Where I'd heard the music years before, but the man there said the music",
	"wouldn't play",
	'And in the streets the children screamed, the lovers cried and the poets dreamed',
	'But not a word was spoken, the church bells all were broken',
	'And the three men I admire most, the Father, Son, and the Holy Ghost',
	'They caught the last train for the coast the day the music died,',
	'N.C.',
	"And they were singin'",
	'',
	'[Chorus]',
	'Bye, bye Miss American Pie',
	'Drove my Chevy to the levee but the levee was dry',
	"And them good old boys were drinkin' whiskey and rye",
	"Singin' this will be the day that I die, this will be the day that I die",
	"They were singin' bye, bye Miss American Pie",
	'Drove my Chevy to the levee but the levee was dry',
	"And them good old boys were drinkin' whiskey and rye",
	"Singin' this will be the day that I die",
];

export default AmericanPie;
